import { useRecoilState } from 'recoil';

import { toastState, initialState } from '@/store';

export const useToast = (): ((message: string, timeoutMS?: number) => void) => {
  const [toast, setToast] = useRecoilState(toastState);
  const TIMEOUT_MS = 1000;
  const toastOn = (message: string, timeoutMS?: number) => {
    // 토스트를 연속으로 띄울 때 이전 타이머 제거
    clearTimeout(toast.timer);
    setToast({
      visible: true,
      message: message,
      timer: setTimeout(() => setToast(initialState), timeoutMS ? timeoutMS : TIMEOUT_MS),
    });
  };
  return toastOn;
};
